import SpringConfigs from 'utils/constants/swarm/spring-configs';

interface Params {
  balance?: number;
  isBonus?: boolean;
  casinoBalance?: number;
}

export const calculateBalance = (
  params: Params,
  frozenBalance = 0,
  rounding = SpringConfigs.PRICE_ROUNDING,
  separator = SpringConfigs.PRICE_SEPARATOR,
  hideTrailingZeros = SpringConfigs.HIDE_TRAILING_ZEROES
): string => {
  let calculatedBalance = ((params.balance ?? 0) - frozenBalance).toFixed(
    rounding
  );

  if (
    SpringConfigs.CASINO_BALANCE_IN_USER_BALANCE &&
    !params.isBonus &&
    params.casinoBalance
  ) {
    switch (SpringConfigs.CASINO_SPORTSBOOK_SWITCHER) {
      case 0:
        calculatedBalance = (
          parseFloat(calculatedBalance) + params.casinoBalance
        ).toFixed(rounding);

        break;
      case 2:
        calculatedBalance = (params.casinoBalance - frozenBalance).toFixed(
          rounding
        );

        break;
    }
  }

  const filteredBalance = +calculatedBalance - parseInt(calculatedBalance);

  if (separator) {
    const parts = calculatedBalance.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    calculatedBalance = parts.join('.');
  }

  if (hideTrailingZeros && filteredBalance === 0) {
    return calculatedBalance.toString().split('.')[0];
  }

  return calculatedBalance;
};

export const calculateCasinoBalance = (
  balance: number,
  rounding = SpringConfigs.PRICE_ROUNDING
): string => {
  return (balance ?? 0).toFixed(rounding);
};

export const calculateBonus = (user: Record<string, any>): string => {
  let balance = 0;

  if (user.bonus_win_balance && Number(user.bonus_win_balance)) {
    balance += user.bonus_win_balance;
  }

  if (
    user.frozen_balance &&
    Number(user.frozen_balance) &&
    !SpringConfigs.SHOULD_IGNORE_USER_FROZEN_BALANCE
  ) {
    balance += user.frozen_balance;
  }

  if (user.bonus_balance && Number(user.bonus_balance)) {
    balance += user.bonus_balance;
  }

  return calculateBalance({
    balance,
    isBonus: true,
    casinoBalance: user.casino_balance
  });
};
